import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralHowDoReferralsWorkIA = function BrandReferralHowDoReferralsWorkIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE = function BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE(strictLocalize) {
  return strictLocalize({
    id: "Sn+nxa",
    defaultMessage: [{
      "type": 0,
      "value": "How do brand referrals work"
    }]
  });
};
var BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION = function BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "jj5C04",
    defaultMessage: [{
      "type": 0,
      "value": "You can earn credit when you refer a brand to sell on Faire. To be eligible for the credit, the brand must use your link or add you as their referrer when they sign up. Note that self-referrals or verbal referrals do not qualify."
    }]
  });
};